/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2023 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import getEnv from '../env';

const POLLUX_MAPPING = {
  'local': 'local.griffon.adobe.com',
  'dev': 'ui-dev.griffon.adobe.com',
  'qa': 'ui-qa.griffon.adobe.com',
  'stage': 'ui-stage.griffon.adobe.com',
  'prod': 'ui.griffon.adobe.com'
};

const env = getEnv();
const polluxUrl = POLLUX_MAPPING[env] || POLLUX_MAPPING.prod;

export default {
  baseURL: `https://${polluxUrl}`
};
